// Material Kit 2 React pages
import Technology from "pages/LandingPages/Technology";

export default function TechnologyPage() {
  return <Technology />;
}
